import React, { useEffect, useState } from 'react'
import SearchBar1 from '../Components/DynamicComp/SearchBar1';
import { FetchCategory, FetchCoupons } from './CouponFunction';
import CouponCard from './CouponCard';
import  CreateCouponForm  from './CreateCouponForm'

const Coupons = () => {
  const [searchquery,setsearchquery]=useState('');
  const [coupons,setcoupons]=useState([]);
  const [category,setcategory]=useState([]);
  const [refresh, setRefresh] = useState(false);
  const [showCreateForm, setShowCreateForm] = useState(false);
  const handlesearch =(query)=>{
   setsearchquery(query);
   console.log(searchquery);
  }
 const handleclick=()=>{
  setShowCreateForm(true);
  }
    const getFilteredCoupons = () => {
    if (!searchquery.trim()) return coupons;
    return coupons.filter((coupon) =>
      coupon.coupon_code.toLowerCase().includes(searchquery.toLowerCase()) ||
      coupon.promotion_type.toLowerCase().includes(searchquery.toLowerCase()) ||
      (coupon.category && coupon.category.toLowerCase().includes(searchquery.toLowerCase()))
    );
  };
   const fetchdata=async()=>{
      await FetchCoupons(setcoupons);
      await FetchCategory(setcategory);
      console.log(category);
      console.log(coupons);
    }
  useEffect(()=>{
    fetchdata()
  },[refresh])
 return (
    <div className="p-4 flex flex-col items-center">
      {showCreateForm && (
       <CreateCouponForm
        onClose={() => setShowCreateForm(false)}
        onCreated={() => setRefresh(prev => !prev)}
        category={category}
       />
      )}
      <h1 className="text-3xl font-bold text-red-600 mb-6 text-center">Coupons</h1>
      <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-6">
        <SearchBar1
          placeholder="Search coupons..."
          onSearch={handlesearch}
          className="w-72"
        />
        <button
          onClick={handleclick}
          className="px-6 py-2 bg-red-500 text-white rounded-md hover:bg-red-800 transition duration-200"
        >
          Create
        </button>
      </div>

      
      <div>
        <p className="text-gray-600">
          Showing results for: <strong>{searchquery}</strong>
        </p>

        {Array.isArray(getFilteredCoupons()) && getFilteredCoupons().length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
           {getFilteredCoupons().map((coupon) => (
             <CouponCard key={coupon.id} coupon={coupon} category={category} setRefresh={setRefresh}/>
             ))}
           </div>
            ) : coupons.length > 0 ? (
           <p className="text-gray-500 mt-4 text-center">No matching coupons found.</p>
           ) : (
            <p className="text-gray-500 mt-4 text-center">No coupons available.</p>
           )}
      </div>
    </div>
  );
}

export default Coupons
